import { createAction } from 'typesafe-actions';
import { ApiError } from '@types';

export const setNotification = createAction('SET_NOTIFICATION', (notification: ApiError) => notification)();
export const dismissNotification = createAction('DISMISS_NOTIFICATION', (id?: string) => id || '')();
export const setSSOError = createAction('sso/SSO_FAILURE', (error: ApiError) => error)();
